"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var eStoryhookBanks;
(function (eStoryhookBanks) {
    eStoryhookBanks["NPC_ACTS"] = "NPC_ACTS";
    eStoryhookBanks["PC_RELATED"] = "PC_RELATED";
    eStoryhookBanks["LOCATION_BASED_URBAN"] = "LOCATION_BASED_URBAN";
    eStoryhookBanks["LOCATION_BASED_WILDERNESS"] = "LOCATION_BASED_WILDERNESS";
})(eStoryhookBanks = exports.eStoryhookBanks || (exports.eStoryhookBanks = {}));
